<template>
    <app-layout class="main">
        <div class="row panel-container">
            <panel>
                <h2 slot="header">Reģistrēties</h2>

                <template v-if="model.id === null">

                    <p v-if="!hasProviderToken">FIZMIX skolotājiem ir slēgtais portāls, kurā reģistrējas fizikas skolotāji ar mykoob vai eklasi. Lai varam apstiprināt tavu profilu, uzraksti, kāpēc Tev nav šādas iespējas un kā esi saistīts ar fizikas pedagoģiju.</p>

                    <form ref="userForm" @submit.prevent="register()" >

                        <input type="file" id="fileUpload" ref="fileUpload" v-show="false" @change="onFileChange($event)" @keydown="errors.remove('generic')"/>

                        <div class="row column avatar-input-container">
                            <img :src="userAvatarSrc" class="avatar clickable" @click="changeAvatar()"/>
                            <button type="button" class="button hollow secondary small" @click.prevent="changeAvatar()">Mainīt bildi</button>
                            <button type="button" class="button hollow secondary small" @click.prevent="removeAvatar()">Dzēst bildi</button>
                        </div>

                        <div class="row">
                            <div class="column small-12 medium-6">
                                <label :class="{ 'is-invalid-label': errors.has('first_name') }">Vārds
                                    <input type="text" name="first_name" id="first_name" v-model="model.first_name" v-validate="'required|max:255'"/>
                                    <span class="form-error is-visible" v-if="errors.has('first_name')">{{ errors.first('first_name') }}</span>
                                </label>
                            </div>
                            <div class="column small-12 medium-6">
                                <label :class="{ 'is-invalid-label': errors.has('last_name') }">Uzvārds
                                    <input type="text" name="last_name" id="last_name" v-model="model.last_name" v-validate="'required|max:255'"/>
                                    <span class="form-error is-visible" v-if="errors.has('last_name')">{{ errors.first('last_name') }}</span>
                                </label>
                            </div>
                        </div>

                        <div class="row">
                            <div class="column small-12 medium-6">
                                <label :class="{ 'is-invalid-label': errors.has('email') }">E-pasts
                                    <input type="email" name="email" id="email" v-model="model.email" v-validate="'required|email|max:255'"/>
                                    <span class="form-error is-visible" v-if="errors.has('email')">{{ errors.first('email') }}</span>
                                </label>
                            </div>
                        </div>

                        <div class="row" v-if="!hasProviderToken">
                            <div class="column small-12 medium-6">
                                <label :class="{ 'is-invalid-label': errors.has('password') }">Parole
                                    <input type="password" name="password" id="password" v-model="model.password" v-validate="this.passwordRules"/>
                                    <span class="form-error is-visible" v-if="errors.has('password')">{{ errors.first('password') }}</span>
                                </label>
                            </div>
                            <div class="column small-12 medium-6">
                                <label :class="{ 'is-invalid-label': errors.has('password_confirmed') }">Atkārtot paroli
                                    <input type="password" name="password_confirmed" id="password_confirmed" v-model="model.password_confirmed"/>
                                    <span class="form-error is-visible" v-if="errors.has('password_confirmed')">{{ errors.first('password_confirmed') }}</span>
                                </label>
                            </div>
                        </div>

                        <div class="row">
                            <div class="column small-12 medium-6">
                                <label :class="{ 'is-invalid-label': errors.has('school_id') }">Skola
                                    <select name="school_id" id="school_id" v-model="model.school_id" v-validate="{ required: !!hasProviderToken }">
                                        <option value="null" disabled hidden>Izvēlies skolu...</option>
                                        <option :value="s.id" v-for="s in schools" :key="s.id" :selected="s.id === model.school_id">{{ s.title }}</option>
                                    </select>
                                    <span class="form-error is-visible" v-if="errors.has('school_id')">{{ errors.first('school_id') }}</span>
                                </label>
                            </div>
                        </div>

                        <div class="row column">
                            <label :class="{ 'is-invalid-label': errors.has('description') }">Īss apraksts
                                <textarea v-model="model.description" name="description" id="description" rows="5" v-validate="'max:500'"></textarea>
                            </label>
                            <span class="form-error is-visible" v-if="errors.has('description')">{{ errors.first('description') }}</span>
                        </div>

                        <div class="row column" v-if="!hasProviderToken">
                            <label :class="{ 'is-invalid-label': errors.has('note') }">Pamatojums
                                <textarea v-model="model.note" name="note" id="note" rows="5" v-validate="(hasProviderToken ? '' : 'required|') + 'max:500'">{{ errors.first('note') }}</textarea>
                            </label>
                            <span class="form-error is-visible" v-if="errors.has('note')">{{ errors.first('note') }}</span>
                        </div>

                        <div class="row column">
                            <label :class="{ 'is-invalid-label': errors.has('newsletter') }">
                                <input type="checkbox" v-model="model.newsletter" name="newsletter" id="newsletter"/>Piekrītu saņemt jaunumus no FIZMIX</router-link>
                            </label>
                            <span class="form-error is-visible" v-if="errors.has('newsletter')">{{ errors.first('newsletter') }}</span>
                        </div>

                        <div class="row column">
                            <label :class="{ 'is-invalid-label': errors.has('terms') }">
                                <input type="checkbox" v-model="model.terms" name="terms" id="terms" v-validate="'required'"/>Iepazinos un piekrītu <router-link :to="{ name: 'page', params: { slug: 'noteikumi' } }" target="_blank">portāla lietošanas noteikumiem</router-link>
                            </label>
                            <span class="form-error is-visible" v-if="errors.has('terms')">{{ errors.first('terms') }}</span>
                        </div>

                        <div class="row column">
                            <vue-recaptcha sitekey="6Lf_GkIUAAAAAN9Y4tcJzkD9Y_ItR5_9Al7exitC" class="form-element" @verify="setRecaptchaResponse($event)"></vue-recaptcha>
                            <span class="form-error is-visible" v-if="errors.has('g_recaptcha_response')">{{ errors.first('g_recaptcha_response') }}</span>
                        </div>

                    </form>

                    <template slot="footer">
                        <button type="button" class="button success" @click.prevent="submitUserForm()" :disabled="submitting">Saglabāt</button>
                    </template>
                </template>

                <template v-else>
                    <p>Paldies! Tava reģistrācija ir pieņemta.</p>
                    <p v-if="!model.verified">Ieej savā e-pastā apstiprināt e-pasta adresi.</p>
                    <p v-if="!model.enabled">Gaidi pziņojumu, ka lapas administrators apstiprinājis tavu kontu.</p>
                    <template slot="footer">
                        <router-link v-if="isAuthenticated" :to="{ name: 'home' }" class="button success" style="margin: 0 auto;">Sākt lietot portālu</router-link>
                    </template>
                </template>
            </panel>
        </div>
    </app-layout>
</template>

<script>
    import AppLayout from '../../layouts/AppLayout'
    import Panel from '../../components/Panel'
    import { mapGetters } from 'vuex'
    import schools from '../../api/schools'
    import { Form } from '../../modules/forms/Form'
    import auth from '../../api/auth'
    import VueRecaptcha from 'vue-recaptcha'

    import addAvatarIcon from '../../../images/avatar-add.svg'

    export default {

        created() {
            // Get schools for drop-down
            schools.get()
                .then(response => this.schools = response.data);

            console.log('Register component provider:', this.provider);

            this.populateProviderData();

            // Pre-fill email field
            Object.assign(this.model, this.$route.query)

            if (typeof(grecaptcha) === 'undefined') {
                const script = document.createElement('script');
                script.type = 'text/javascript';
                script.async = true;
                script.src = 'https://www.google.com/recaptcha/api.js' +
                    '?onload=vueRecaptchaApiLoaded&render=explicit&hl=lv';

                document.body.appendChild(script);
            }

            this.$validator.localize('lv', {
                custom: {
                    terms: {
                        required: 'Obligāti jāpiekrīt lietošanas noteikumiem.'
                    }
                }
            });

            this.$validator.extend('password_strength', {
                getMessage: field => 'Parolē jābūt cipariem, mazajiem un lielajiem burtiem',
                validate: value => {
                    const strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])");
                    return strongRegex.test(value);
                }
            })
        },

        data: function () {
            return {
                model: new Form({
                    email: null,
                    first_name: null,
                    last_name: null,
                    password: null,
                    password_confirmed: null,
                    school_id: null,
                    description: null,
                    newsletter: false,
                    note: null,// registration note
                    file: null,// new avatar file for uploading
                    g_recaptcha_response: null,

                    // set by saved response
                    id: null,
                    verified: false,
                    enabled: false,
                }),

                // avatar upload preview
                avatar: null,

                schools: [],

                submitting: false,
            }
        },

        methods: {
            changeAvatar() {
                this.$el.querySelector('#fileUpload').click();
            },

            onFileChange(event) {
                this.model.file = event.target.files[0];

                // Preview selected image
                const reader = new FileReader();
                reader.onload = e => this.avatar = e.target.result;
                reader.readAsDataURL(event.target.files[0]);
            },

            removeAvatar() {
                this.avatar = null;
                this.model.file = null;
            },

            submitUserForm() {
                this.register();
            },

            populateProviderData() {
                if (this.hasProviderToken) {
                    this.model.email = _.get(this.provider.provider_user, 'email');
                    this.model.first_name = _.get(this.provider.provider_user, 'first_name');
                    this.model.last_name = _.get(this.provider.provider_user, 'last_name');
                }
            },

            register() {
                return this.$validator.validateAll().then(result => {
                    if (!result) return;

                    this.submitting = true;

                    const data = { ...this.model.data() };

                    // Append provider data
                    if (this.hasProviderToken) {
                        data.provider = {
                            token: this.provider.provider_token,
                            name: this.provider.provider_name
                        }
                    }

                    console.log("Registering", data);
                    return auth.register(data)
                        .then(response => {
                            this.submitting = false;
                            Object.assign(this.model, response.data);

                            // Create request to social user resolver to get Fizmix access_token
                            // and log in user automatically after registration
                            if (this.provider) {
                                auth.loginSocial({ network: this.provider.provider_name, access_token: this.provider.provider_token})
                                    .then(response => {
                                        this.$store.dispatch('login', response.data);
                                        // Reset provider data
                                        this.$store.dispatch('setProvider', null);
                                    }, response => {
                                        this.$notify({ title: 'Neizdevās pierakstīties!', type: 'error' })
                                    })
                                    .catch(error => {
                                        this.$notify({ title: 'Neizdevās pierakstīties!', type: 'error' })
                                    })
                            }

                            return response;
                        }, response => {
                            this.submitting = false;
                            console.log('r2', response.data);

                            const errors = response.data.errors;

                            // Record errors for available fields only
                            for (let field in errors) {
                                if (!errors.hasOwnProperty(field)) continue;

                                if (this.model.hasOwnProperty(field)) {
                                    this.errors.add(field, errors[field][0], 'register')
                                }
                            }

                            return response;
                        })
                        .catch(error => {
                            this.submitting = false;
                            //console.log(error.response)
                            throw error
                        })
                })


            },

            setRecaptchaResponse(response) {
                this.model.g_recaptcha_response = response;
            },
        },

        computed: {

            ...mapGetters(['provider', 'isAuthenticated']),

            userAvatarSrc: function () {
                return this.avatar ? this.avatar : addAvatarIcon;
            },

            passwordRules: function () {
                return (this.hasProviderToken ? '' : 'required|') + 'min:8|password_strength|max:255|confirmed:password_confirmed'
            },

            hasProviderToken: function () {
                return this.provider && this.provider.provider_token
            }
        },

        watch: {
            'provider': function (val, oldVal) {
                console.log('provider changed');
                this.populateProviderData();
            }
        },

        components: { Panel, AppLayout, VueRecaptcha }
    }
</script>

<style lang="scss" scoped>
    @import "../../../sass/settings";
    @import "../../../sass/mixins";
    @import "../../../sass/foundation/config";

    .avatar {
        width: 86px;
        height: 86px;
        border-radius: 50%;
    }

    .avatar-input-container {
        margin-bottom: $form-spacing;

    > * {
        margin-bottom: 0;

    &:not(:last-child) {
         margin-right: $form-spacing;
     }
    }
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/views/auth/Register.vue